import { render, staticRenderFns } from "./Landing_Deposit.vue?vue&type=template&id=c79da91c&scoped=true&"
import script from "./Landing_Deposit.vue?vue&type=script&lang=js&"
export * from "./Landing_Deposit.vue?vue&type=script&lang=js&"
import style0 from "./Landing_Deposit.vue?vue&type=style&index=0&id=c79da91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79da91c",
  null
  
)

export default component.exports